export default __webpack_public_path__ + "static/invest-in-pomerania-logo-eb374306f3eec0041569edb5afc3f337.png";